import { 
    FETCH_LANGUAGE,
    FETCH_LANGUAGE_SUCCESS,
    FETCH_LANGUAGE_FAILED,
    EDIT_LANGUAGE
  } from "../store/types";
  
import defaultTranslations from "../other/language-en.json";

const defaultLangItem = {
  id: 'en',
  default: true,
  langName: 'English',
  langLocale: 'en',
  dateLocale: 'en',
  keyValuePairs: defaultTranslations
};

export const defaultFallbackLang = defaultTranslations;

export const INITIAL_STATE = {
  langlist: [defaultLangItem],
  defaultLanguage: defaultTranslations,
  loading: false,
  error: {
    flag: false,
    msg: null
  }
}

export const languagereducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_LANGUAGE:
      return {
        ...state,
        loading: true
      };
    case FETCH_LANGUAGE_SUCCESS:
      return {
        ...state,
        ...action.payload,
        defaultLanguage: action.payload?.defaultLanguage || defaultFallbackLang,
        loading: false
      };
    case FETCH_LANGUAGE_FAILED:
      return {
        ...state,
        langlist: state.langlist || [defaultLangItem],
        defaultLanguage: state.defaultLanguage || defaultFallbackLang,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
      case EDIT_LANGUAGE:
        return state;
      default:
        return state;
    }
  };